/* Swatch PDP (3 Oct 2026): switches prints across separate Shopify products with no page load.
   Data comes from the #spwData JSON rendered by sections/spw-pdp.liquid. */
(function () {
  'use strict';
  var el = document.getElementById('spwData');
  if (!el) return;
  var D = JSON.parse(el.textContent);
  var $ = function (id) { return document.getElementById(id); };

  // [handle, option1 value or null, print key, label]. Option values must match Shopify exactly.
  var FAMILIES = {
    'pants-men': { cut: 'pants', fit: 'men', name: 'Slouchies', prints: [
      ['pizza-pants', null, 'pizza', 'Pizza'], ['dumpling-pants-blue', null, 'dumpblue', 'Dumpling Blue'],
      ['printed-slouchies-for-men', 'Cookies & Cream', 'cookies', 'Cookies & Cream'],
      ['printed-slouchies-for-men', 'Ice-Cream', 'icecream', 'Ice Cream'],
      ['printed-slouchies-for-men', 'Peanut Butter', 'pb', 'Peanut Butter']] },
    'pants-women': { cut: 'pants', fit: 'women', name: 'Slouchies', prints: [
      ['pizza-pants', null, 'pizza', 'Pizza'], ['dumpling-pants-pink', null, 'dumppink', 'Dumpling Pink'],
      ['printed-slouchies-women', 'Cookies & Cream', 'cookies', 'Cookies & Cream'],
      ['printed-slouchies-women', 'Ice Cream', 'icecream', 'Ice Cream'],
      ['printed-slouchies-women', 'Peanut Butter', 'pb', 'Peanut Butter']] },
    'shorts-men': { cut: 'shorts', fit: 'men', name: 'PJ Shorts', prints: [
      ['pizza-shorts', null, 'pizza', 'Pizza'], ['dumpling-shorts-blue', null, 'dumpblue', 'Dumpling Blue'],
      ['pj-shorts-for-men', 'Cookies & Cream', 'cookies', 'Cookies & Cream'],
      ['pj-shorts-for-men', 'Ice Cream', 'icecream', 'Ice Cream'],
      ['pj-shorts-for-men', 'Peanut Butter', 'pb', 'Peanut Butter']] },
    'shorts-women': { cut: 'shorts', fit: 'women', name: 'PJ Shorts', prints: [
      ['womens-pizza-shorts', null, 'pizza', 'Pizza'], ['dumpling-shorts-pink', null, 'dumppink', 'Dumpling Pink'],
      ['printed-pj-short', 'Cookies & Cream', 'cookies', 'Cookies & Cream'],
      ['printed-pj-short', 'Ice-Cream', 'icecream', 'Ice Cream'],
      ['printed-pj-short', 'Peanut Butter', 'pb', 'Peanut Butter'],
      ['printed-pj-short', 'Peach', 'peach', 'Peach']] },
    'tees-men': { cut: 'tees', fit: 'men', name: 'Comfort Tee', prints: [
      ['pizza-tee', null, 'pizzatee', 'Pizza'],
      ['printed-tee-for-men', 'Peanut Butter Cookie', 'pbtee', 'Peanut Butter Cookie'],
      ['printed-tee-for-men', 'Pink Butter', 'pinkbutter', 'Pink Butter'],
      ['printed-tee-for-men', 'Brown Butter', 'brownbutter', 'Brown Butter']] },
    'tees-women': { cut: 'tees', fit: 'women', name: 'Comfort Tee', prints: [
      ['pizza-tee', null, 'pizzatee', 'Pizza'],
      ['printed-tee-for-women', 'Peanut Butter', 'pbtee', 'Peanut Butter Cookie'],
      ['printed-tee-for-women', 'Pink Butter', 'pinkbutter', 'Pink Butter'],
      ['printed-tee-for-women', 'Brown Butter', 'brownbutter', 'Brown Butter']] }
  };
  // Unisex Pizza Pants: lead with the model who matches the fit. Matched by file name, so reordering or adding media can't shift it.
  var FIT_ORDER = {
    'pizza-pants|men': ['Pizza-Pants-Unisex-10', 'Pizza-Pants-Unisex-08', 'Pizza-Pants-Unisex-07', 'Pizza-Pants-Unisex-11', 'Pizza-Pants-Unisex-13', 'Pizza-Pants-Unisex-09', '02-tile-print', '05-two-people'],
    'pizza-pants|women': ['Pizza-Pants-Unisex-02', 'Pizza-Pants-Unisex-03', 'Pizza-Pants-Unisex-01', '05-two-people', '02-tile-print', 'Pizza-Pants-Unisex-09'],
    'pizza-tee|men': ['Pizza-Tee-Unisex-07', 'Pizza-Tee-Unisex-06', 'Pizza-Tee-Unisex-08', 'Pizza-Tee-Unisex-03', 'Pizza-Tee-Unisex-05'],
    'pizza-tee|women': ['Pizza-Tee-Unisex-03', 'Pizza-Tee-Unisex-04', 'Pizza-Tee-Unisex-05', 'Pizza-Tee-Unisex-01', 'Pizza-Tee-Unisex-02'],
    'pizza-shorts|men': ['Pizza-Shorts-Men-01', 'Pizza-Shorts-Men-02', 'Pizza-Shorts-Men-04', 'Pizza-Shorts-Men-03'],
    'womens-pizza-shorts|women': ['Pizza-Shorts-Women-01', 'Pizza-Shorts-Women-02', 'Pizza-Shorts-Women-03', 'Pizza-Shorts-Women-04', 'Pizza-Shorts-Women-05']
  };
  var fileOf = function (u) { return u.split('?')[0].split('/').pop(); };
  // Swatch face: the print's own character art (tile includes its colour), or the tee's fabric colour.
  var SWATCH = {
    pizza: { art: 'pizza', bg: '#fbe7cf', blend: true }, dumpblue: { art: 'bao-blue' },
    dumppink: { art: 'bao-pink', bg: '#f5d6cd' }, cookies: { art: 'oreo' }, icecream: { art: 'sundae' },
    pb: { art: 'pb' }, peach: { art: 'peach', bg: '#fde3c8' },
    pizzatee: { bg: '#f7f5f1' }, pbtee: { bg: '#a9d0e5' }, pinkbutter: { bg: '#e8dfe2' }, brownbutter: { bg: '#c79b80' }
  };
  var CUTS = ['pants', 'shorts', 'tees'];
  var FITS = [['men', "Men's"], ['women', "Women's"]];
  // Slouchies are one unisex cut: the toggle only picks whose photos (and which Dumpling colour) you see (Zac, 4 Oct 2026).
  var FITS_UNISEX = [['men', 'On him'], ['women', 'On her']];
  // Any 2 food prints, save $29 (automatic Shopify discount "Any 2 food prints, save $29", tools/bundles_config.py,
  // 17 Oct 2026). Replaced "2 Slouchies for $149", the Dumpling Shorts 10% and the Pizza Tee $10 combo. Every print on
  // this page is in the deal, so any two pieces get $29 off (two pants: $178 -> $149).
  var FOOD_OFF = 2900;
  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  var money = function (c) { var n = c / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  // ---- build print records from the product data ----
  Object.keys(FAMILIES).forEach(function (k) {
    var f = FAMILIES[k];
    f.prints = f.prints.map(function (r) {
      var prod = D.products[r[0]];
      if (!prod) return null;
      var vs = prod.variants.filter(function (v) { return r[1] === null || v.o[0] === r[1]; });
      var sizeOf = function (v) { return r[1] === null ? v.o[0] : v.o[1]; };
      var sizes = {};
      vs.forEach(function (v) { sizes[sizeOf(v)] = v; });
      var photos = prod.media.filter(function (m) { return m.type === 'image'; }); // videos stay out of the swipe gallery
      var imgs, order = FIT_ORDER[r[0] + '|' + f.fit];
      if (order) imgs = order.map(function (name) {
        var hit = photos.filter(function (m) { return fileOf(m.src).indexOf(name) === 0; })[0]; return hit && hit.src;
      }).filter(Boolean);
      else if (r[1] === null) imgs = photos.map(function (m) { return m.src; });
      else imgs = photos.filter(function (m) { return m.alt === r[1]; }).map(function (m) { return m.src; });
      return { handle: r[0], opt: r[1], key: r[2], label: r[3], prod: prod, sizes: sizes, images: imgs.slice(0, 8),
        price: vs[0] ? vs[0].p : 0, compare: vs[0] ? vs[0].c : 0 };
    }).filter(Boolean);
  });

  // ---- initial state from the product the visitor landed on ----
  var q = new URLSearchParams(location.search);
  var startVariant = +(q.get('variant') || D.variant);
  var state = { cut: 'pants', fit: 'men', print: null, size: null };
  (function () {
    var wantFit = q.get('fit');
    var hits = [];
    Object.keys(FAMILIES).forEach(function (k) {
      FAMILIES[k].prints.forEach(function (p) {
        if (p.handle !== D.current) return;
        var v = null; Object.keys(p.sizes).forEach(function (s) { if (p.sizes[s].id === startVariant) v = s; });
        hits.push({ fam: FAMILIES[k], print: p, size: v });
      });
    });
    var hit = hits.filter(function (h) { return h.size && (!wantFit || h.fam.fit === wantFit); })[0] ||
              hits.filter(function (h) { return !wantFit || h.fam.fit === wantFit; })[0] || hits[0];
    if (!hit) return;
    state.cut = hit.fam.cut; state.fit = hit.fam.fit; state.print = hit.print.key;
    if (q.get('variant') && hit.size) state.size = hit.size; // only keep a size the visitor actually chose
  })();

  var family = function () { return FAMILIES[state.cut + '-' + state.fit]; };
  // The same print can carry a different key in another fit or cut; follow it there instead of falling back to Pizza.
  var TWIN = { dumpblue: ['dumppink'], dumppink: ['dumpblue'], pizza: ['pizzatee'], pizzatee: ['pizza'], pb: ['pbtee'], pbtee: ['pb'] };
  var current = function () {
    var f = family(), keys = [state.print].concat(TWIN[state.print] || []);
    for (var i = 0; i < keys.length; i++) { var hit = f.prints.filter(function (p) { return p.key === keys[i]; })[0]; if (hit) return hit; }
    return f.prints[0];
  };
  var inStock = function (p, s) { return !!(p.sizes[s] && p.sizes[s].a); };
  var anyStock = function (p) { return SIZES.some(function (s) { return inStock(p, s); }); };

  // One photo width for render and preload, so a warmed photo is exactly the one the gallery asks for.
  var W = Math.min(1200, Math.ceil((innerWidth >= 900 ? innerWidth * 0.28 : innerWidth * 0.62) * (window.devicePixelRatio || 1) / 100) * 100);
  var sized = function (u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + W; };
  var warmed = {};
  function warm(p, n) {
    p.images.slice(0, n || 1).forEach(function (u) {
      var src = sized(u); if (warmed[src]) return; warmed[src] = 1;
      var i = new Image(); i.decoding = 'async'; i.src = src;
    });
  }
  function warmFamily() {
    family().prints.forEach(function (p) { warm(p, 1); });
    (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () { family().prints.forEach(function (p) { warm(p, 2); }); });
  }

  function face(key) {
    var s = SWATCH[key];
    if (!s) return '';
    return '<span class="spw-face' + (s.blend ? ' spw-face--blend' : '') + '" style="background:' + (s.bg || '#fff') + '">' +
      (s.art ? '<img src="' + D.art[s.art] + '" alt="" width="120" height="120">' : '') + '</span>';
  }

  // ---- render ----
  var lastGallery = null;
  function renderGallery(p) {
    var t = $('spwTrack');
    t.innerHTML = p.images.map(function (u, i) {
      return '<img src="' + sized(u) + '" width="800" height="1000" alt="' + esc(p.label + ' ' + family().name + ', photo ' + (i + 1)) + '"' +
        (i < 2 ? (i ? '' : ' fetchpriority="high"') : ' loading="lazy"') + ' decoding="async">';
    }).join('');
    t.scrollLeft = 0;
    $('spwCount').textContent = '1 / ' + p.images.length;
    // once the page is idle, start the next couple of photos so the first swipe never waits
    (window.requestIdleCallback || function (f) { return setTimeout(f, 300); })(function () { loadAhead(0, 3); });
  }
  // Photos past the first two are lazy; pull them forward just ahead of where the visitor is swiping.
  function loadAhead(from, n) {
    var imgs = $('spwTrack').children;
    for (var i = from + 1; i <= from + n && i < imgs.length; i++) if (imgs[i].loading === 'lazy') imgs[i].loading = 'eager';
  }
  var galleryIndex = function (t) { var w = t.firstElementChild ? t.firstElementChild.offsetWidth + 8 : 1; return Math.round(t.scrollLeft / w); };
  $('spwTrack').addEventListener('scroll', function () {
    var i = galleryIndex(this);
    $('spwCount').textContent = (i + 1) + ' / ' + this.children.length;
    loadAhead(i, 2);
  }, { passive: true });
  $('spwTrack').addEventListener('touchstart', function () { loadAhead(galleryIndex(this), 3); }, { passive: true });
  $('spwTrack').addEventListener('pointerdown', function () { loadAhead(galleryIndex(this), 3); });

  function renderOptions() {
    $('spwCuts').innerHTML = CUTS.map(function (c) {
      var f = FAMILIES[c + '-' + state.fit];
      return '<button class="spw__tab" role="tab" data-cut="' + c + '" aria-selected="' + (c === state.cut) + '">' + f.name + ' <small>(' + f.prints.length + ')</small></button>';
    }).join('');
    $('spwFits').setAttribute('aria-label', state.cut === 'pants' ? 'Photos' : 'Fit');
    $('spwFits').innerHTML = (state.cut === 'pants' ? FITS_UNISEX : FITS).map(function (f) {
      return '<button type="button" role="radio" data-fit="' + f[0] + '" aria-checked="' + (f[0] === state.fit) + '">' + f[1] + '</button>';
    }).join('');
    $('spwSwatches').innerHTML = family().prints.map(function (p) {
      var out = state.size ? !inStock(p, state.size) : !anyStock(p);
      return '<button type="button" class="spw-sw' + (out ? ' is-out' : '') + '" role="radio" data-print="' + p.key + '" aria-checked="' + (p.key === current().key) + '"' +
        ' aria-label="' + esc(p.label + (out ? ', sold out' + (state.size ? ' in ' + state.size : '') : '')) + '" title="' + esc(p.label) + '">' + face(p.key) + '</button>';
    }).join('');
    var p = current();
    $('spwSizes').innerHTML = SIZES.filter(function (s) { return p.sizes[s]; }).map(function (s) {
      var ok = inStock(p, s);
      return '<button type="button" class="spw__size' + (ok ? '' : ' is-out') + '" role="radio" data-size="' + s + '" aria-checked="' + (s === state.size) + '"' +
        (ok ? '' : ' aria-disabled="true" aria-label="' + s + ', sold out"') + '>' + s + '</button>';
    }).join('');
    $('spwSizeName').textContent = (state.size ? ': ' + state.size : '') + (state.cut === 'pants' ? ' · Unisex fit' : '');
    $('spwPair').innerHTML = state.cut === 'pants' ? 'Any 2 Slouchies for <b>$149</b>. Mix prints, mix his and hers.' : 'Any 2 food prints, <b>save $29</b>. Mix and match.';
  }

  function renderBuy() {
    var p = current(), ok = state.size && inStock(p, state.size);
    var v = state.size && p.sizes[state.size];
    var price = v ? v.p : p.price, compare = v ? v.c : p.compare;
    $('spwPrice').textContent = money(price);
    $('spwCompare').textContent = compare > price ? money(compare) : '';
    $('spwAtc').textContent = !state.size ? 'Select a size' : ok ? 'Add to bag · ' + money(price) : 'Sold out in ' + state.size;
    $('spwAtc').setAttribute('aria-disabled', String(!ok));
    $('spwDockBtn').textContent = ok ? 'Add' : state.size ? 'Sold out' : 'Size';
    $('spwDockName').textContent = p.label + ' ' + family().name;
    $('spwDockSize').textContent = state.size ? 'Size ' + state.size + ' · ' + money(price) : 'Pick a size';
    $('spwDockSwatch').innerHTML = face(p.key);
    var note = '';
    if (state.size && !ok) {
      var alt = family().prints.filter(function (x) { return inStock(x, state.size); }).map(function (x) { return x.label; });
      if (alt.length) note = 'In your size: ' + alt.join(', ');
    }
    $('spwStock').textContent = note;
  }

  // ---- the box under Add to bag: one offer at a time (Zac, 4 Oct 2026; matching sets 17 Oct 2026) ----
  //  Pizza tee              -> Complete the outfit: Pizza Pants in the same fit
  //  everything else        -> Make it a matching set: the other fit in the same print (his and hers), any print allowed
  //  Both pieces go in together with one tap and the food print deal takes $29 off (two Slouchies = $149).
  var setSize = null, setKeyShown = null, matchPrint = null, matchFor = null;
  function companion() {
    var p = current(), fit = state.fit, other = fit === 'men' ? 'women' : 'men';
    if (state.cut === 'tees' && p.key === 'pizzatee') {
      var pf = FAMILIES['pants-' + fit], c = pf && pf.prints.filter(function (x) { return x.key === 'pizza'; })[0];
      if (c && anyStock(c)) return { kind: 'set', label: 'Complete the outfit', note: 'Save $29', print: c, fam: pf, need: 'Pick a size for the pants' };
    }
    var mf = FAMILIES[state.cut + '-' + other];
    var choices = mf ? mf.prints.filter(anyStock) : [];
    if (!choices.length) return null;
    var key = p.key + '|' + state.cut + '|' + fit;
    if (matchFor !== key || choices.indexOf(matchPrint) < 0) { // follow the main print until the shopper picks another
      var same = [p.key].concat(TWIN[p.key] || []);
      matchPrint = choices.filter(function (x) { return same.indexOf(x.key) > -1; })[0] || choices[0];
      matchFor = key;
    }
    var who = other === 'men' ? 'his' : 'her';
    var both = p.price + matchPrint.price - FOOD_OFF;
    var same = [p.key].concat(TWIN[p.key] || []).indexOf(matchPrint.key) > -1;
    var noun = state.cut === 'tees' ? ' tee' : ' pair';
    return { kind: 'match', label: 'Make it a matching set', print: matchPrint, fam: mf, choices: choices, who: who,
      note: 'Add ' + who + noun + (same ? ' in the same print' : ' in ' + matchPrint.label) + '. Both for ' + money(both),
      need: 'Pick ' + who + ' size' };
  }
  function renderSet() {
    var box = $('spwSet'), c = companion();
    $('spwPair').hidden = !!c; // the box already says it
    if (!c) { box.hidden = true; box.innerHTML = ''; setKeyShown = null; return; }
    var cp = c.print, key = c.kind + cp.handle + (cp.opt || '') + c.fam.cut + c.fam.fit;
    if (key !== setKeyShown) {
      var keep = setKeyShown && setSize && cp.sizes[setSize] && cp.sizes[setSize].a; // switching prints keeps the size
      setKeyShown = key; if (!keep) setSize = null; // never pick a size for the shopper
    }
    var sizes = SIZES.filter(function (s) { return cp.sizes[s]; });
    var v = setSize && cp.sizes[setSize];
    var piece = cp.label + (c.fam.cut === 'tees' ? ' Tee' : ' ' + c.fam.name) + (c.kind !== 'match' ? '' : c.fam.cut === 'pants' ? (c.fam.fit === 'women' ? ', for her' : ', for him') : (c.fam.fit === 'women' ? ", women's" : ", men's"));
    var p = current(), mv = state.size && p.sizes[state.size];
    var full = (mv ? mv.p : p.price) + (v ? v.p : cp.price), now = full - FOOD_OFF;
    var cta = !(v && v.a) ? c.need : !state.size ? 'Now pick your size above' : !inStock(p, state.size) ? 'Yours is sold out in ' + state.size :
      'Add both · ' + money(now);
    var ready = v && v.a && state.size && inStock(p, state.size);
    box.hidden = false;
    box.className = 'spw__set spw__set--' + (c.kind === 'match' ? 'pair' : 'set');
    box.innerHTML = '<p class="spw__set-label">' + c.label + (c.note ? ' <span>' + c.note + '</span>' : '') + '</p>' +
      '<div class="spw__set-row"><img src="' + sized(cp.images[0]) + '" alt="" width="64" height="80" loading="lazy">' +
      '<div class="spw__set-info"><b>' + esc(piece) + '</b><span>Both ' + money(now) + ' <s>' + money(full) + '</s></span></div></div>' +
      (c.kind === 'match' ? '<div class="spw__set-sw" role="radiogroup" aria-label="Print for ' + c.who + ' pair">' + c.choices.map(function (x) {
        return '<button type="button" class="spw-sw spw-sw--sm" role="radio" data-pairprint="' + x.key + '" aria-checked="' + (x === cp) + '" aria-label="' + esc(x.label) + '" title="' + esc(x.label) + '">' + face(x.key) + '</button>';
      }).join('') + '</div>' : '') +
      '<div class="spw__set-sizes" role="radiogroup" aria-label="Size for the ' + esc(piece) + '">' + sizes.map(function (s) {
        var ok = inStock(cp, s);
        return '<button type="button" class="spw__set-size' + (ok ? '' : ' is-out') + '" role="radio" data-setsize="' + s + '" aria-checked="' + (s === setSize) + '"' + (ok ? '' : ' aria-disabled="true"') + '>' + s + '</button>';
      }).join('') + '</div>' +
      '<button type="button" class="spw__set-add" data-setadd' + (ready ? '' : ' aria-disabled="true"') + '>' + cta + '</button>';
  }
  $('spwSet').addEventListener('click', function (e) {
    var pp = e.target.closest('[data-pairprint]');
    if (pp) { var k = pp.dataset.pairprint, c0 = companion(); matchPrint = (c0 && c0.choices || []).filter(function (x) { return x.key === k; })[0] || matchPrint; later(renderSet); return; }
    var s = e.target.closest('[data-setsize]');
    if (s && s.getAttribute('aria-disabled') !== 'true') { setSize = s.dataset.setsize; later(renderSet); return; }
    var b = e.target.closest('[data-setadd]');
    if (!b) return;
    var c = companion(), v = c && setSize && c.print.sizes[setSize];
    if (!v || !v.a) { toast(c ? c.need : 'Pick a size'); return; }
    var p = current();
    if (!state.size) { $('spwSizes').scrollIntoView({ block: 'center', behavior: 'smooth' }); toast('Pick your size first'); return; }
    if (!inStock(p, state.size) || adding) return;
    var tag = c.kind === 'match' ? 'Matching set' : 'Complete the outfit';
    adding = true; b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: p.sizes[state.size].id, quantity: 1, properties: { _bundle: tag } }, { id: v.id, quantity: 1, properties: { _bundle: tag } }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'Could not add'); }); return r.json(); })
      .then(openMiniCart)
      .catch(function (er) { toast(er.message || 'Could not add to bag'); })
      .then(function () { adding = false; b.removeAttribute('aria-busy'); });
  });

  function renderText() {
    var p = current(), f = family();
    $('spwTitle').textContent = p.label + ' ' + f.name;
    $('spwPrintName').textContent = p.label;
    $('spwAbout').innerHTML = p.prod.about;
    $('spwDetails').innerHTML = p.prod.details; $('spwDetailsWrap').hidden = !p.prod.details;
    $('spwGuarantee').innerHTML = p.prod.guarantee; $('spwGuaranteeWrap').hidden = !p.prod.guarantee;
    $('spwIcons').innerHTML = p.prod.icons.map(function (i) {
      return '<div class="spw__icon"><img src="' + i.src + '" alt="" width="28" height="28" loading="lazy"><span>' + esc(i.name) + '</span></div>';
    }).join('');
    document.title = p.label + ' ' + f.name + ' | Slouch Potato';
  }

  var shownHandle = D.current;
  function render() {
    var p = current();
    state.print = p.key;
    if (lastGallery !== p) { renderGallery(p); lastGallery = p; }
    renderOptions(); renderText(); renderBuy(); renderSet();
    var v = state.size && p.sizes[state.size];
    var u = new URLSearchParams();
    if (v) u.set('variant', v.id);
    else if (p.opt !== null) { var any = p.sizes[Object.keys(p.sizes)[0]]; if (any) u.set('variant', any.id); }
    if (p.handle === 'pizza-pants' || p.handle === 'pizza-tee') u.set('fit', state.fit);
    history.replaceState(null, '', p.prod.url + (u.toString() ? '?' + u : ''));
    if (p.handle !== shownHandle) { shownHandle = p.handle; swapBelowFold(p); }
  }

  // ---- below the fold: reload the product's own sections (videos, reviews, features) for the new print ----
  var swapTimer, swapSeq = 0;
  function swapBelowFold(p) {
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      var mine = document.getElementById('spw').closest('.shopify-section');
      var ids = [], node = mine && mine.nextElementSibling;
      for (; node; node = node.nextElementSibling) if (node.classList.contains('shopify-section') && !node.querySelector('[data-spw-keep]')) ids.push(node.id.replace('shopify-section-', ''));
      if (!ids.length) return;
      var seq = ++swapSeq;
      fetch(p.prod.url + '?view=swatch&sections=' + ids.join(','), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (res) {
        if (!res || seq !== swapSeq) return;
        ids.forEach(function (id) {
          var old = document.getElementById('shopify-section-' + id);
          if (!old || !res[id]) return;
          var tmp = document.createElement('div'); tmp.innerHTML = res[id];
          var fresh = tmp.firstElementChild; if (!fresh) return;
          old.replaceWith(fresh);
          // innerHTML does not run scripts; re-create them so sliders, video players and review widgets start up
          Array.prototype.forEach.call(fresh.querySelectorAll('script'), function (s) {
            var n = document.createElement('script');
            Array.prototype.forEach.call(s.attributes, function (a) { n.setAttribute(a.name, a.value); });
            if (n.getAttribute('type') === 'lazyJs') n.removeAttribute('type');
            n.textContent = s.textContent; s.replaceWith(n);
          });
        });
        document.dispatchEvent(new CustomEvent('spw:sections-swapped', { detail: { handle: p.handle } }));
      }).catch(function () {});
    }, 350); // wait for the visitor to settle on a print before reloading the sections
  }

  // ---- interactions ----
  // Redraw after the tap finishes bubbling: other scripts on the store also read the tapped button.
  var later = function (fn) { setTimeout(fn, 0); };
  $('spwSwatches').addEventListener('pointerdown', function (e) {
    var b = e.target.closest('[data-print]');
    if (b) warm(family().prints.filter(function (p) { return p.key === b.dataset.print; })[0], 2);
  });
  $('spwSwatches').addEventListener('click', function (e) {
    var b = e.target.closest('[data-print]');
    if (!b || b.dataset.print === state.print) return;
    state.print = b.dataset.print; later(render);
  });
  $('spwSizes').addEventListener('click', function (e) {
    var b = e.target.closest('[data-size]');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    state.size = b.dataset.size; later(render);
  });
  $('spwCuts').addEventListener('click', function (e) {
    var b = e.target.closest('[data-cut]');
    if (!b || b.dataset.cut === state.cut) return;
    state.cut = b.dataset.cut; later(function () { render(); warmFamily(); });
  });
  $('spwFits').addEventListener('click', function (e) {
    var b = e.target.closest('[data-fit]');
    if (!b || b.dataset.fit === state.fit) return;
    state.fit = b.dataset.fit; later(function () { render(); warmFamily(); });
  });
  ['spwSwatches', 'spwSizes', 'spwFits'].forEach(function (id) {
    $(id).addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      var items = Array.prototype.slice.call(this.querySelectorAll('[role=radio]:not([aria-disabled=true])'));
      var i = items.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault();
      var next = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
      var key = Object.keys(next.dataset)[0], val = next.dataset[key];
      var group = this;
      next.click(); // re-renders the group, so refocus the fresh button once it exists
      setTimeout(function () { var fresh = group.querySelector('[data-' + key + '="' + val + '"]'); if (fresh) fresh.focus(); }, 0);
    });
  });

  // ---- add to bag: hands off to the theme's own mini cart ----
  function openMiniCart() {
    // the theme loads its cart script after the first interaction, so give it a moment before falling back to /cart
    var tries = 0;
    (function open() {
      var cart = window.PROJ && window.PROJ.ajaxcart;
      if (cart && cart.updateCart && cart.opencart) { cart.updateCart(); cart.opencart(); }
      else if (++tries < 20) setTimeout(open, 100);
      else location.href = '/cart';
    })();
    if (typeof window.addedToCartKlaviyo === 'function') { try { window.addedToCartKlaviyo(); } catch (e) {} }
  }
  var adding = false;
  function add() {
    var p = current();
    if (!state.size) { $('spwSizes').scrollIntoView({ block: 'center', behavior: 'smooth' }); toast('Pick a size first'); return; }
    if (!inStock(p, state.size) || adding) return;
    var id = p.sizes[state.size].id;
    adding = true; $('spwAtc').setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); }); return r.json(); })
      .then(openMiniCart)
      .catch(function (e) { toast(e.message || 'Could not add to bag'); })
      .then(function () { adding = false; $('spwAtc').removeAttribute('aria-busy'); });
  }
  $('spwAtc').addEventListener('click', add);
  $('spwDockBtn').addEventListener('click', add);

  // ---- size guide sheet ----
  var lastFocus = null;
  $('spwGuideBtn').addEventListener('click', function () { lastFocus = this; $('spwGuide').hidden = false; $('spwGuide').querySelector('[data-close]').focus(); });
  $('spwGuide').addEventListener('click', function (e) { if (e.target === this || e.target.closest('[data-close]')) { this.hidden = true; if (lastFocus) lastFocus.focus(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !$('spwGuide').hidden) { $('spwGuide').hidden = true; if (lastFocus) lastFocus.focus(); } });

  var tt;
  function toast(msg) {
    var t = $('spwToast'); t.textContent = msg; t.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('is-on'); }, 1800);
  }

  // sticky add-to-bag once the main button scrolls away (phones)
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      $('spwDock').classList.toggle('is-on', on);
      $('spwDock').setAttribute('aria-hidden', String(!on));
      $('spwDockBtn').tabIndex = on ? 0 : -1;
    }).observe($('spwAtc'));
  }

  // Reviews: the rating jumps to them, and the long Klaviyo list starts folded with a button to show the rest.
  var reviews = document.querySelector('[id$="__reviews"]'), rating = $('spwRating');
  if (reviews && rating) {
    var link = document.createElement('a');
    link.className = rating.className; link.id = rating.id; link.href = '#' + reviews.id;
    link.setAttribute('aria-label', rating.getAttribute('aria-label') + ', read reviews');
    link.innerHTML = rating.innerHTML; rating.replaceWith(link);
  }
  if (reviews) {
    reviews.classList.add('spw-reviews', 'is-folded');
    var more = document.createElement('button');
    more.type = 'button'; more.className = 'spw-reviews__more'; more.textContent = 'Show all reviews';
    more.addEventListener('click', function () { reviews.classList.remove('is-folded'); more.remove(); });
    reviews.appendChild(more);
  }

  render(); warmFamily();
})();
